import * as React from 'react';
import { ITEM_WIDTH_OVER_XL, ITEM_WIDTH_SP, VerticalListArrows, } from '@lean-body/components/molecules/vertical_list_arrows';
import { LessonComponent } from '../molecules/lesson_component';
export const LessonComponentCarousel = ({ lessons, classObject, itemMarginRight, itemsPadding, addFavoriteLesson, unFavoriteLesson, isMin, disableHistoryPush, }) => {
    const addFavorite = (lesson) => {
        lesson.isFavorite = true;
        addFavoriteLesson(lesson.id);
    };
    const unFavorite = (lesson) => {
        lesson.isFavorite = false;
        unFavoriteLesson(lesson.id);
    };
    return (React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: isMin ? ITEM_WIDTH_SP : ITEM_WIDTH_OVER_XL, items: lessons.map((v) => (React.createElement(LessonComponent, { lesson: v, addFavoriteLesson: () => addFavorite(v), unFavoriteLesson: () => unFavorite(v), isMin: isMin, disableHistoryPush: disableHistoryPush }))) }));
};
